import Home from "../pages/home/Home";
const home = [{

    path: "/",
    title: "Home",
    component: Home,
    props: {}
}]

export default home;